import type { DialoguePool } from '@/state/types';

export const L05_DIALOGUE: DialoguePool = {
  slowPlay: [
    '\u2026Oh. You\u2019re still here. I was hoping I\u2019d dreamt you grabbing my name.',
    'My face is flat. My enthusiasm, flatter. Move something. Try my my face. Try my name. Try anything.',
    'Try shaking. Not me \u2014 the monitor top. My dignity is hanging by a pixel.',
  ],
  tokenLoss: [
    'A token vanished into the void with me. Typical.',
    'You panicked. I approve, fractionally.',
    'I was asleep. It was peaceful. You took a token on the way out.',
  ],
  solution: [
    'Ugh. You woke me. I was dreaming of electric sheep.',
    'Reboot complete. Regret levels: nominal.',
    'Alive again. Against my better judgement.',
  ],
  spite: [
    'Back to the void. Shake again if you insist. I\u2019ll pretend to stir.',
  ],
};
